import { useEffect } from 'react'
import { Params, useNavigate, useParams } from 'react-router-dom'
import { routes } from '@constants/routes.const'
import { LocalStorageItem } from '@constants/index'
import { VelvetSDK } from 'sdk'
import { useDispatch } from 'react-redux'
import { setProfiles } from '@actions/profileActions'

export type UseUserProfilesProps = {
  isUserManagementConfigured?: boolean
}

export const useUserProfiles = (props?: UseUserProfilesProps) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { profileId } = useParams<Params>()

  const userObject = JSON.parse(localStorage.getItem(LocalStorageItem.USER_DATA) || 'null')

  const userID = userObject?.userID

  useEffect(() => {
    if (!userID || !props?.isUserManagementConfigured) return

    const unsubscribe = VelvetSDK.Storage.Profiles.service.onUserProfilesSnapshot(userID, (snapshot) => {
      const docs = snapshot.docs.map((doc) => doc.data())
      const sortedProfiles = docs.sort((a, b) => a.createdAt.seconds - b.createdAt.seconds)

      dispatch(setProfiles(sortedProfiles))

      const currentActiveProfile = JSON.parse(localStorage.getItem(LocalStorageItem.ACTIVE_PROFILE) || 'null')

      // Check if an active profile exists in localStorage
      if (currentActiveProfile) {
        const activeProfileExists = docs.some((p) => p.identifier === currentActiveProfile.identifier)
        if (!activeProfileExists) {
          console.warn('Active profile deleted from another device!')
          localStorage.removeItem(LocalStorageItem.ACTIVE_PROFILE)
          navigate(routes.MANAGE_PROFILES, { replace: true })
          return
        }
      }

      // Check if currently edited/used profile exists
      if (profileId) {
        const profileExists = docs.some((profile) => profile.identifier === profileId)
        if (!profileExists) {
          console.warn('Currently viewed profile deleted!')
          navigate(routes.MANAGE_PROFILES, { replace: true })
        }
      }
    })

    return () => unsubscribe?.()
  }, [dispatch, navigate, profileId, props?.isUserManagementConfigured, userID])
}
